import styled from "styled-components";

export const Component = styled.div`
  display: flex;
	justify-content: center;
  margin-top: 250px;
  font-size: 100px;
	color: black;
	font-weight: 400;
`